import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from '../../../../../common/elements';
import { WebinarOverview, SeriesInfo, ModuleSlider } from './elements';
import webinarsActions from '../../../../../../actions/training/webinars/webinars';
import BackButton from "../../../../../common/elements/BackButton";


class WebinarSeriesPage extends Component {

    componentDidMount() {
        const { getCurrentWebinar, getCurrentWebinarModules, params } = this.props;
        getCurrentWebinar(params.webinarId);
        getCurrentWebinarModules(params.webinarId, params.seriesId);
    };

    render() {
        const { webinar, modules, params } = this.props;
        if (!webinar && !modules) {
            return <Loader />;
        }
        const thisSeries = webinar && webinar.series.filter(s => parseInt(s.id, 10) === parseInt(params.seriesId, 10))[0];
        const hasAccess = webinar && webinar.series.filter((series) => { return series.has_access === 1 })[0];
        return (
            <article className="container webinar-view-body" >
                <BackButton />
                <WebinarOverview webinar={webinar} />
                <SeriesInfo webinar={webinar} series={thisSeries} />
                {modules && modules.length > 0 && <ModuleSlider params={params} modules={modules} hasAccess={hasAccess} />}
            </article>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        webinar: state.webinars.current_webinar,
        modules: state.webinars.current_webinar_modules,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCurrentWebinar: (webinarId) => dispatch(webinarsActions.getCurrentWebinar(webinarId)),
        getCurrentWebinarModules: (webinarId, seriesId) => dispatch(webinarsActions.getCurrentWebinarModules(webinarId, seriesId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebinarSeriesPage);



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/WebinarSeriesPage.js